export enum RouteEnums {
  transactionHistory = "/history/transactions-history",
  goods = "/goods/goods-management",
  item = "/goods/item-management",
  field = "/goods/field-management",
  category = "/goods/category-management",
  variant = "/goods/variant-management",
  storage = "/storages/storage-management",
  inventory = "/storages/inventory-management",
  partner = "/partners/partner-management",
  wallet = "/partners/wallet-management",
  customerProfile = "/partners/profile-management",
  partnerKey = "/partners/partner-key-management",
  balanceTicket = "/partners/balance-ticket-management",
  supplierFeature = "/partners/suplier-feature-management",
  deliveryService = "/partners/delivery-service-management",
  user = "/users/user-management",
  role = "/users/role-management",
  permission = "/users/permission-management",
  feature = "/users/feature-management",
  configuration = "/systems/configuration-management",
  errorCode = "/systems/error-code-management",
  actionLog = "/systems/action-log-management",
  file = "/systems/file-management",
  transactionWarehouse = "/loading-beta/transaction-warehouse",
}
